import Title from './src/Title';
export default Title;